export class TypeKeys {
  static BoxLineItem: string = "BoxLineItem";
  static CircleItem: string = "CircleItem";
  static CircleSelectItem: string = "CircleSelectItem";
  static ComboBoxItem: string = "ComboBoxItem";
  static CrossItem: string = "CrossItem";
  static DateItem: string = "DateItem";
  static TimeItem: string = "TimeItem";
  static CalculateItem: string = "CalculateItem";
  static ImageItem: string = "ImageItem";
  static SignItem: string = "SignItem";
  static LineItem: string = "LineItem";
  static PolylineItem: string = "PolylineItem";
  static RichTextBoxItem: string = "RichTextBoxItem";
  static TextBoxItem: string = "TextBoxItem";
  static MovableTextBoxItem: string = "MovableTextBoxItem";
  static CheckBoxItem: string = "CheckBoxItem";
  static TriangleItem: string = "TriangleItem";
  static RollItem: string = "RollItem";
  static ExternalDataItem: string = "ExternalDataItem";
  static ExternalProcessItem: string = "ExternalProcessItem";
  static BarcodeItem: string = "BarcodeItem";
  static PositionCorrectItem: string = "PositionCorrectItem";
  static MovableImageItem: string = "MovableImageItem";
  static NewPageItem: string = "NewPageItem";
  static GraphItem: string = "GraphItem";
  static RangeOfMotionItem: string = "RangeOfMotionItem";
  static HeaderFooterTextItem: string = "HeaderFooterTextItem";
  static JoinTextItem: string = "JoinTextItem";
  static BarItem: string = "BarItem";
  static StampItem: string = "StampItem";
}
